function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_9445_23382)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.2732 14.9666V17.3398C23.2732 18.9134 22.6481 20.4226 21.5354 21.5353C20.4227 22.648 18.9135 23.2731 17.3399 23.2731H14.9814",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9814 0.741699H17.3399C18.9135 0.741699 20.4227 1.3668 21.5354 2.4795C22.6481 3.5922 23.2732 5.10135 23.2732 6.67495V9.03346",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.741699 9.03346V6.67495C0.741699 5.10135 1.3668 3.5922 2.4795 2.4795C3.5922 1.3668 5.10135 0.741699 6.67495 0.741699H9.04825",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.04825 23.2731H6.67495C5.10135 23.2731 3.5922 22.648 2.4795 21.5353C1.3668 20.4226 0.741699 18.9134 0.741699 17.3398V14.9666",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.22998 14.2102V17.785H9.78993",
  stroke: "white",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.92343 14.0767L6.22998 17.7849",
  stroke: "white",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.7847 9.78993V6.22998H14.21",
  stroke: "white",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.0767 9.92343L17.7849 6.22998",
  stroke: "white",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9445_23382"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));
function SvgIcnEnableFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEnableFullscreen);
export default __webpack_public_path__ + "static/media/icn-enable-fullscreen.a54880296136e78f338654b508d462ae.svg";
export { ForwardRef as ReactComponent };